import commonApi from './CommonApi.js';

const base = '/v1/admin/pivotReports';
const data = (response) => response.data;

export default {
	getCatalog: async () => commonApi().get(`${base}/catalog`).then(data),
	getFieldValues: async (cube, field, search) => commonApi().get(`${base}/fieldValues`, { params: { cube, field, search } }).then(data),
	run: async (definition) => commonApi().post(`${base}/run`, definition).then(data),
	exportToExcel: async (definition) => commonApi().post(`${base}/exportToExcel`, definition, { responseType: 'blob' })
		.then((response) => {
			const fileURL = window.URL.createObjectURL(new Blob([response.data]));
			const fileLink = document.createElement('a');
			fileLink.href = fileURL;
			fileLink.setAttribute('download', 'PivotReport.xlsx');
			document.body.appendChild(fileLink);
			fileLink.click();
			fileLink.remove();
		}),
	getList: async () => commonApi().get(`${base}/list`).then(data),
	get: async (id) => commonApi().get(`${base}/${id}`).then(data),
	create: async (model) => commonApi().post(base, model).then(data),
	update: async (id, model) => commonApi().put(`${base}/${id}`, model).then(data),
	remove: async (id) => commonApi().delete(`${base}/${id}`).then(data)
};
